import { emit } from "@/core/services/eventBus";
import { EVENTS } from "@/core/constants/events";
import { isDashboardApp } from "@/core/services/domain.service";
import { routes } from "@/routing/routes";
import routerDashboard from "@/routing/routerDashboard";
import routerWeb from "@/routing/routerWeb";

export const cartNavigationService = {
  /**
   * @returns {void}
   */
  goToCart(from) {
    if (isDashboardApp()) {
      this.goToCartDashboard(from);
    } else {
      this.goToCartPublicApp(from);
    }
  },

  /**
   * @returns {void}
   */
  goToCartDashboard(from) {
    if (routes.buybackCreate.name !== from) {
      routerDashboard.push({
        name: routes.buybackCreate.name,
        query: {
          goToCartFromOtherRoute: true,
        },
      });
    }

    emit(EVENTS.buybackCreationWizard.goToCartFromWizardEvent);
  },

  /**
   * @returns {void}
   */
  goToCartPublicApp(from) {
    if (routes.buybackCreate.name !== from) {
      routerWeb.push({
        name: routes.buybackCreate.name,
        query: {
          goToCartFromOtherRoute: true,
        },
      });
    } else {
      emit(EVENTS.buybackCreationWizard.goToCartFromWizardEvent);
    }
  },
};
